import React, { useState } from 'react';
import Link from 'next/link';

interface ProjectCardProps {
  title: string;
  image: string;
  technologies?: string[];
  audience?: string;
  seeDetailsLabel?: string;
  locale: string;
  slug: string;
}

const ProjectCard: React.FC<ProjectCardProps> = ({
  title,
  image,
  technologies = [],
  audience,
  seeDetailsLabel = 'Voir détails',
  locale,
  slug,
}) => {
  const [hovered, setHovered] = useState(false);
  const projectUrl = slug;

  return (
    <div className="flex flex-col items-start w-full">
      <div
        className={`relative bg-white rounded-2xl shadow-lg overflow-hidden 
                    transition-all duration-500 cursor-pointer w-full
                    ${hovered ? 'h-[340px]' : 'h-[260px]'} group`}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {/* Image */}
        <img
          alt={title}
          className={`w-full h-full object-cover transition-transform duration-500 ease-out 
                      ${hovered ? 'scale-110' : 'scale-100'}`}
          src={image}
        />

        {/* Overlay + contenu */}
        <div
          className={`absolute inset-0 flex flex-col justify-end transition-all duration-500 
                      ${hovered ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        >
          <div
            className="absolute inset-0 bg-gradient-to-t 
                       from-[#2c003e]/90 via-[#2c003e]/40 to-transparent 
                       transition-all duration-500 rounded-2xl"
          />
          <div className="relative z-10 flex flex-col items-start p-6 pb-5 w-full">
            <h3 className="text-xl font-extrabold text-white mb-1 drop-shadow-lg">
              {title}
            </h3>
            {audience && (
              <p className="text-base font-medium text-white mb-3 drop-shadow-md">
                {audience}
              </p>
            )}
            <Link
              href={`/${locale}/projects/${projectUrl}`}
              className="ml-auto px-5 py-2 rounded-full bg-white text-[#2c003e] 
                         font-semibold shadow-md hover:shadow-lg hover:scale-105 
                         transition-transform duration-300 text-sm"
              style={{ marginTop: '8px' }}
            >
              {seeDetailsLabel}
            </Link>
          </div>
        </div>
      </div>

      {/* Contenu affiché hors hover */}
      <h3
        className={`text-lg font-semibold text-gray-900 tracking-wide mt-6 mb-1 
                    transition-all duration-300 
                    ${hovered ? 'opacity-0 h-0 m-0 p-0 pointer-events-none' : 'opacity-100'}`}
      >
        {title}
      </h3>
      {technologies.length > 0 && (
  <div
    className={`flex flex-wrap gap-2 mb-1 transition-all duration-300 
                ${hovered ? 'opacity-0 h-0 m-0 p-0 pointer-events-none' : 'opacity-100'}`}
  >
    {technologies.map((tech, index) => (
      <span
        key={index}
        className="px-3 py-1 text-xs font-medium text-gray-900 bg-gray-100 rounded-full shadow-sm hover:bg-gray-100 transition"
      >
        {tech}
      </span>
    ))}
  </div>
)}

    </div>
  );
};

export default ProjectCard;
